module.exports = __webpack_public_path__ + "img/p5.4274e78b.webp";